import ReactGA from 'react-ga'

const PREFIX_CANDIDATOS = '[2023-Candidatos]'
const PREFIX_CONSEJEROS = '[2023-Consejeros]'

const reportAnalytics = (component: string, ...args: string[]) => {
  const analyticsCandidatos: { [x: string]: ReactGA.EventArgs } = {
    circle_filter_event: {
      action: 'Circle Filter Event',
      category: `${PREFIX_CANDIDATOS} Filter by List`,
      label: `Se aplica el filtro de la lista ${args[0]}`,
    },
    cleaned_filters_main_mobile: {
      action: 'Click on clean filters mobile',
      category: `${PREFIX_CANDIDATOS} Filter`,
      label: 'Se clickeó el botón para limpiar filtros móvil en la página principal',
    },
    cleaned_filters_sheet_mobile: {
      action: 'Click on clean filters mobile',
      category: `${PREFIX_CANDIDATOS} Filter`,
      label: 'Se clickeó el botón para limpiar filtros móvil en el menu de filtrado móvil',
    },
    click_on_candidate_mobile: {
      action: 'Click on candidate mobile',
      category: `${PREFIX_CANDIDATOS} Show candidate information`,
      label: `Se escogió el candidato ${args[0]} con el id ${args[1]}`,
    },
    escrutada_event: {
      action: 'OnMouseEvent on  Circle Label',
      category: `${PREFIX_CANDIDATOS} Display % Information From Region`,
      label: `Popup de la información de la región ${args[0]}`,
    },
    filter_event: {
      action: `SetFilter on ${args[0]}`,
      category: `${PREFIX_CANDIDATOS} Filter`,
      label: `Se aplicó el filtro ${args[1]} en ${args[0]}`,
    },
    filter_event_mobile: {
      action: 'Filter mobile',
      category: `${PREFIX_CANDIDATOS} Filter`,
      label: 'Se filtró en móvil',
    },
    go_to_filters_main_mobile: {
      action: 'Click on filters button mobile',
      category: `${PREFIX_CANDIDATOS} Filter`,
      label: 'Se clickeó el botón de filtros en móvil en la página principal',
    },
    iframe_event: {
      action: 'Medium Used iframe',
      category: `${PREFIX_CANDIDATOS} Iframe`,
      label: `Medio ${args[0]} ha utilizado el iframe`,
    },
    live_video_event: {
      action: 'Clicked on Live Component',
      category: `${PREFIX_CANDIDATOS} Live`,
      label: `Se clickea en el componente para ver el video en vivo modo ${args[0]}`,
    },
    mobile_live_video_event: {
      action: 'Clicked on Live Component',
      category: `${PREFIX_CANDIDATOS} Live Mobile`,
      label: 'Se clickea en el componente para ver el video en vivo desde un móvil',
    },
    pEntrada: {
      action: 'Clicked on “2020 Plebiscito” Button Resultado por Comunas',
      category: `${PREFIX_CANDIDATOS} Display Information`,
      label: `Desplegar barra porcentajes Apruebo vs Rechazo en /2022/plebiscito por región en ${args[0]}`,
    },
    pEntradaSummary: {
      action: 'Clicked on “2020 Plebiscito” Button Summary',
      category: `${PREFIX_CANDIDATOS} Display Information`,
      label: `Desplegar barra porcentajes Apruebo vs Rechazo en /2022/plebiscito en ${args[0]}`,
    },
    region_navegation: {
      action: `Clicked on Region ${args[0]}`,
      category: `${PREFIX_CANDIDATOS} Navegation`,
      label: `Se navega desde ${args[1]} hacia el endpoint ${args[2]}`,
    },
    sVuelta: {
      action: 'Clicked on “2021 2da Vuelta” Button Resultado por Comunas',
      category: `${PREFIX_CANDIDATOS} Display Information`,
      label: `Desplegar barra porcentajes Kast vs Boric en /2022/plebiscito por región en ${args[0]}`,
    },
    sVueltaSummary: {
      action: 'Clicked on “2021 2da Vuelta” Button Summary',
      category: `${PREFIX_CANDIDATOS} Display Information`,
      label: `Desplegar barra porcentajes Kast vs Boric en /2022/plebiscito en ${args[0]}`,
    },
    show_more_event: {
      action: `Show more info  on ${args[0]}`,
      category: `${PREFIX_CANDIDATOS} Display Information`,
      label: `Se abrió más información en ${args[0]}`,
    },
    sort_table_event: {
      action: 'Sort Candidates Table',
      category: `${PREFIX_CANDIDATOS} Sort`,
      label: `Se aplica ordenación sobre la columna ${args[0]}, con orden: ${args[1]}}`,
    },
    timeline_event: {
      action: 'Click event on Time Line',
      category: `${PREFIX_CANDIDATOS} Display % Information for specific hour`,
      label: `Se eligió la hora ${args[0]} del timeline de mesas escrutadas mediante el ${args[1]}`,
    },
  }
  const analyticsConsejeros: { [x: string]: ReactGA.EventArgs } = {
    click_mapa_comuna: {
      action: 'Click en mapa comuna',
      category: `${PREFIX_CONSEJEROS} Click en mapa comuna`,
    },
    consejeros_candidate_card_close: {
      action: 'Consejero card closed',
      category: `${PREFIX_CONSEJEROS} Consejero card closed`,
      label: `Se cierra la card del consejero: ${args[0]}`,
    },
    consejeros_candidate_circle_click: {
      action: 'Consejero circle click event',
      category: `${PREFIX_CONSEJEROS} Consejero clicked`,
      label: `Se clickea al candidato: ${args[0]}`,
    },
    consejeros_candidate_circle_mouse_enter: {
      action: 'Consejero circle mouse enter',
      category: `${PREFIX_CONSEJEROS} Consejero mouse enter`,
      label: `Mouse sobre el candidato: ${args[0]}`,
    },
    consejeros_candidate_circle_mouse_leave: {
      action: 'Consejero mouse leave',
      category: `${PREFIX_CONSEJEROS} Consejero mouse leave`,
      label: `Mouse sale del candidato: ${args[0]}`,
    },
    consejeros_ver_detalle_de_circunscripcion: {
      action: 'Ver detalle de circunscripción',
      category: `${PREFIX_CONSEJEROS} Ver detalle de circunscripción`,
      label: `Selección de la circunscripción ${args[0]}`,
    },
    consejeros_ver_detalle_por_circunscripcion: {
      action: 'Ver detalle por circunscripción',
      category: `${PREFIX_CONSEJEROS} Ver detalle por circunscripción`,
      label: `Click en Ver detalle por circunscripción`,
    },
    consejeros_ver_detalle_por_comuna: {
      action: 'Click comuna en mapa',
      category: `${PREFIX_CONSEJEROS} Click comuna en mapa`,
      label: `Click comuna en mapa: ${args[0]}`,
    },
  }
  ReactGA.event(analyticsCandidatos[component] || analyticsConsejeros[component])
}

export default reportAnalytics
